import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type TopPageUrlResponse = {
  url: string;
};

export const tenantSiteApiClient = {
  topPageUrl: async (): Promise<ApiResult<TopPageUrlResponse>> => {
    return await axiosClient.get('/tenant/top-page-url');
  },
};
